export default "__VITE_ASSET__zVlYrKHh__"